import type { DrawApiResponse, ISubscribeDrawUseCase } from '../../../domain/entry.js';
import type { DrawQueryOptions } from '../../../lib/entry.js';

export type ISubscribeDrawController = ReturnType<typeof subscribeDrawController>;

type HandleDrawUpdateFn = (drawForecast: DrawApiResponse) => void;

type UnsubscribeSocketFn = () => void;

/**
 * Controller to get a specific draw for a product.
 *
 * @param subscribeDrawUseCase Use case to subscribe to a specific draw for forecast result data
 * @returns Controller executor function
 */
export function subscribeDrawController(subscribeDrawUseCase: ISubscribeDrawUseCase) {
  return function controller(queryInfo: DrawQueryOptions, onUpdate?: HandleDrawUpdateFn): UnsubscribeSocketFn {
    const handleDrawUpdate = (drawResponse: DrawApiResponse): void => {
      if (onUpdate) {
        onUpdate(drawResponse);
      }
    };

    return subscribeDrawUseCase.execute({ ...queryInfo, onUpdate: handleDrawUpdate });
  };
}
